import { ChangeEvent, useState } from "react";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Switch,
  Chip,
  SelectChangeEvent,
  CardMedia,
  Input,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from "@mui/icons-material/Delete";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";
const AddProduct = () => {
  const [type, setType] = React.useState("default");
  const [images, setImages] = useState<(string | null)[]>(Array(8).fill(null));
  const [fileName, setFileName] = useState<string>("");
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };
  const [Range, setRange] = useState("default");
  const [isRecommended, setIsRecommended] = useState(true);
  const [selectedColors, setSelectedColors] = useState<string[]>([
    "Red",
    "Blue",
    "Green",
  ]);
  const [selectedSizes, setSelectedSizes] = useState<string[]>([
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
  ]);
  const handleImageChange = (
    event: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      const newImages = [...images];
      newImages[index] = imageUrl;
      setImages(newImages);
    }
  };

  const handleRemoveImage = (index: number) => {
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  };
  const navigate = useNavigate();
  return (
    <>
      <div className="main_title">
        <h1>Add Product</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-products")}>Manage Products</button> -{" "}
          Add
        </p>
      </div>
      <div className="cards custom_form_details">
        {/* <Typography variant="h6" fontWeight={600} mb={2}>
          Product
        </Typography> */}
        <div className="form">
          <div className="gap_m w_100">
            <div className="control_group w_100">
              <label htmlFor="text">Product Name</label>
              <TextField
                id="text"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="email">Product Category</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Category
                </MenuItem>
                <MenuItem value="broadcast">Category1</MenuItem>
                <MenuItem value="email">Category2</MenuItem>
                <MenuItem value="email">Category3</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="email">Product Sub-Category</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Sub-Category
                </MenuItem>
                <MenuItem value="broadcast">sub-Category1</MenuItem>
                <MenuItem value="email">sub-Category2</MenuItem>
                <MenuItem value="email">sub-Category3</MenuItem>
              </Select>
            </div>
            <div className="control_group w_33">
              <label htmlFor="email">Brand</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Brand
                </MenuItem>
                <MenuItem value="broadcast">Brand1</MenuItem>
                <MenuItem value="email">Brand2</MenuItem>
                <MenuItem value="email">Brand3</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <TextField
                label="Product Description*"
                fullWidth
                multiline
                minRows={4}
                placeholder="Enter product description..."
              />
            </div>
            <div className="control_group w_50">
              <TextField
                label="Product Details*"
                fullWidth
                multiline
                minRows={2}
                placeholder="Enter product details information..."
              />
            </div>
            <div className="control_group w_50">
              <TextField
                label="Delivery & Returns*"
                fullWidth
                multiline
                minRows={2}
                placeholder="Enter delivery & returns information..."
              />
            </div>
          </div>

          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography>Add Product is Recommended*</Typography>
              <SwitchToggle />
            </Box>
          </Grid>
        </div>
      </div>

      {/* Attributes */}
      <div className="cards variants">
        <Box sx={{ borderRadius: 2, mt: 3 }}>
          <Typography variant="h6" fontWeight={600} mb={2}>
            Add Attributes
          </Typography>

          <div className="select_variant">
            <Typography variant="subtitle1" fontWeight={500}>
              <SwitchToggle />
              Colour
            </Typography>
            <Box display="flex" gap={1} mt={1}>
              {selectedColors.map((color) => (
                <Chip
                  key={color}
                  label={color}
                  color={
                    color === "Red"
                      ? "error"
                      : color === "Green"
                        ? "success"
                        : "primary"
                  }
                  variant="outlined"
                />
              ))}
            </Box>
          </div>

          <div className="select_variant">
            <Typography variant="subtitle1" fontWeight={500}>
              <SwitchToggle />
              Size
            </Typography>
            <Box display="flex" gap={1} mt={1}>
              {selectedSizes.map((size) => (
                <Chip key={size} label={size} variant="outlined" />
              ))}
            </Box>
          </div>
        </Box>
        <div className="create_variant">
          <ul>
            <li>
              <strong>Colour</strong>
              Black
            </li>
            <li>
              <strong>Size</strong>L
            </li>
            <li>
              <Button>
                <DeleteIcon />
              </Button>
            </li>
          </ul>
          <div className="form">
            <div className="gap_m">
              <div className="control_group w_33">
                <label htmlFor="text">Variant Name</label>
                <TextField
                  id="text"
                  placeholder="Enter Variant Name"
                  fullWidth
                  hiddenLabel
                />
              </div>

              <div className="control_group w_33">
                <label htmlFor="text">Price</label>
                <TextField
                  id="text"
                  placeholder="Enter Price"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="text">Discounted Price</label>
                <TextField
                  id="text"
                  placeholder="Enter Discounted Price"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="email">Comission*</label>
                <TextField
                  id="text"
                  placeholder="Enter Comission"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="text">Quantity for Inventory*</label>
                <TextField
                  id="text"
                  placeholder=" Quantity for Inventory*"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="text">Maximum Purchase Limit</label>
                <TextField
                  id="text"
                  placeholder=" Purchase Limit"
                  fullWidth
                  hiddenLabel
                />
              </div>
            </div>
          </div>

          <Typography variant="subtitle1" fontWeight={500} mt={3}>
            Product Images or Videos*
          </Typography>
          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fill, 120px)"
            gap={2}
            mt={1}
          >
            {images.map((image, i) => (
              <div key={i}>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder square">
                      <figure>
                        <CardMedia
                          component="img"
                          image={image}
                          alt={`photo-${i}`}
                        />
                      </figure>
                      <CloseIcon onClick={() => handleRemoveImage(i)} />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image"
                    htmlFor={`icon-button-file-${i}`}
                  >
                    <Input
                      sx={{ display: "none" }}
                      id={`icon-button-file-${i}`}
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                    />
                    <span className="upload_image_holder square">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="edit" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
            ))}
          </Box>
        </div>
        <div className="w_100 mt_20">
          <Button className="btn_primary" size="large">
            Save
          </Button>
        </div>
      </div>
    </>
  );
};

export default AddProduct;
